import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import AlertInfo from '@components/common/alert/AlertInfo';
import { GIButton, Modal } from 'app-components';
import { ModalContextType } from '@contexts/modalContext';
import { ConditionalRendering } from '@components/common/conditional-rendering';

const StyledAlertWrapper = styled.div`
    .gi-alert {
        padding: 0.625rem;
    }
`;

const StyledErrorWrapper = styled.div`
    .usa-alert {
        padding: 0.625rem;
    }
`;

const StyledButton = styled.div`
    .gi-button {
        text-transform: none;
    }
`;

interface IModalProps extends ModalContextType {
    onDeleteHandler: () => void;
    errorMessage?: string | null;
}

export default function DeleteDocumentModal({ onDeleteHandler, closeModal, errorMessage }: IModalProps) {
    const intl = useIntl();
    
    function onClose() {
        closeModal('deleteDocumentModal');
    }

    return (
        <Modal id="deleteDocumentModal">
            <Modal.Header
                id="deleteDocumentModalHeader"
                titleId="dmi.applicantVerifications.confirmDelete"
                onHide={onClose}
            />
            <Modal.Body id="deleteDocumentModalBody">
                <>
                    <ConditionalRendering isTrue={!!errorMessage}>
                        <StyledErrorWrapper>
                            <div className="usa-alert gi-alert gi-alert__left-accent gi-alert__error">
                                <div className="gi-alert__body">
                                    <p className="gi-alert__text">
                                        {errorMessage && intl.formatMessage({ id: errorMessage as string })}
                                    </p>
                                </div>
                            </div>
                        </StyledErrorWrapper>
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!errorMessage}>
                        <StyledAlertWrapper>
                            <AlertInfo id="dmi.applicantVerifications.alert.deleteFile" />
                        </StyledAlertWrapper>
                    </ConditionalRendering>
                </>
            </Modal.Body>
            <Modal.Controls>
                <StyledButton>
                    <ConditionalRendering isTrue={!errorMessage}>
                        <GIButton
                            id="cancel-button-document-modal"
                            onClickHandler={onClose}
                            variant="secondary"
                            labelId="button.cancel"
                        />
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!errorMessage}>
                        <GIButton
                            id="delete-button-document-modal"
                            onClickHandler={onDeleteHandler}
                            variant="primary"
                            labelId="dmi.button.delete"
                        />
                    </ConditionalRendering>
                    <ConditionalRendering isTrue={!!errorMessage}>
                        <GIButton
                            id="close-button-document-modal"
                            onClickHandler={onClose}
                            variant="primary"
                            labelId="button.close"
                        />
                    </ConditionalRendering>
                </StyledButton>
            </Modal.Controls>
        </Modal>
    );
}
